<template>
  <v-application-view title="Cashbox">
    <template v-slot:actions>
      <v-forward />
    </template>
    <v-layout row class="mx-2">
      <v-flex class="px-2 pt-2" md9>
        <v-card tile outlined>
          <v-tabs vertical>
            <v-tab>Salary</v-tab>
            <v-tab>Shifts</v-tab>
            <v-tab-item>
              <v-salary-view>
                <v-card-text>
                  <v-layout row class="px-2">
                    <v-flex class="px-1"><v-text-field label="Amount" type="number" 
                        v-model="params.amount"/></v-flex>
                    <v-flex class="px-1"><v-autocomplete label="Payment type" v-bind:items="payment_types"
                        v-model="params.type"/></v-flex>
                  </v-layout>
                </v-card-text>
              </v-salary-view>
              <v-card-text>
                <v-text-field label="Comment" prepend-inner-icon="mdi-comment-text"
                  hint="Write a comment to understant order"/>
              </v-card-text>
              <v-salary-discounts-view />
              <v-card-actions>
                <v-spacer />
                <v-btn text color="success">
                  apply
                </v-btn>
              </v-card-actions>
            </v-tab-item>
            <v-tab-item>
              <v-list>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon large>mdi-account-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Firdavs Beknazarov
                    </v-list-item-title>
                    <v-list-item-subtitle>SEO of SSASS Comapany</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-card flat>
                <v-card-text>
                  <v-layout row class="px-2">
                    <v-flex class="px-1"><v-text-field label="Amount" type="number" 
                        v-model="params.amount"/></v-flex>
                    <v-flex class="px-1"><v-autocomplete label="Payment type" v-bind:items="payment_types"
                        v-model="params.type"/></v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-text>
                  <v-text-field label="Comment" prepend-inner-icon="mdi-comment-text"
                    hint="Write a comment to understant order"/>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="success" outlined>
                    Pay in
                  </v-btn>
                  <v-btn outlined color="success">
                    Pay out
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
  </v-application-view>
</template>
<script>
export default {
  name: 'CashboxEmployee',
  data: () => ({
    payment_types: [
      {text: 'Cash', value: 'cash'},
      {text: 'Bank', value: 'bank'},
      {text: 'Credit card', value: 'card'},
    ],
    params: {
      type: 'cash',
      amount: null
    }
  })
}
</script>
